import React, { FunctionComponent } from 'react';
import { Text } from '@react-pdf/renderer';
import { STYLES } from '../constants';
import useTitle from './useTitle';

const Title: FunctionComponent = function () {
  const { title } = useTitle();

  const TextTag = Text as unknown as FunctionComponent<any>;

  return (
    <TextTag
      style={{
        ...STYLES.mb4,
        ...STYLES['text-16-20-em'],
        ...STYLES['text-neutral-900'],
      }}
    >
      {title}
    </TextTag>
  );
};

export default Title;
